import Reveal from '@/components/base/Reveal';

const flowSteps = [
  {
    name: 'Josh Hastings',
    role: 'Strategy + Direction',
    style: 'border-primary-500/30 bg-primary-500/10',
    dot: 'bg-primary-400',
  },
  {
    name: 'Marketing Team / Specialists',
    role: 'Implementation + Optimization',
    style: 'border-white/10 bg-background-100',
    dot: 'bg-foreground-500',
  },
  {
    name: 'Your Business',
    role: 'Leads + Customers + Revenue',
    style: 'border-accent-500/30 bg-accent-500/10',
    dot: 'bg-accent-400',
  },
];

export default function TeamSection() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-4 rounded-3xl bg-gradient-to-tr from-primary-500/15 via-transparent to-background-300/40 blur-2xl" />
              <div className="relative rounded-2xl overflow-hidden border border-white/10">
                <div className="relative w-full aspect-[4/5]">
                  <img
                    src="/assets/images/Lauren-Hastings-4.jpg"
                    alt="Josh Hastings as strategist backed by a specialist team"
                    title="Josh Hastings — Personal Strategy, Team Execution"
                    className="absolute inset-0 w-full opacity-70 h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </Reveal>

          {/* Copy + diagram */}
          <Reveal delay={100}>
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
              Personal Strategy. Team Execution.
            </span>
            <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
              You Work With Josh — Backed by a Team.
            </h2>
            <p className="mt-5 text-foreground-600 leading-relaxed">
              Josh remains the strategist and central advisor behind the
              process. He is your point of clarity, direction, and
              accountability.
            </p>
            <p className="mt-4 text-foreground-600 leading-relaxed">
              For{' '}
              <strong className="text-foreground-950 font-semibold">
                Done For You
              </strong>{' '}
              engagements, he is supported by a team responsible for
              implementation across the necessary marketing channels and
              systems.
            </p>
            <p className="mt-4 text-foreground-600 leading-relaxed">
              For{' '}
              <strong className="text-foreground-950 font-semibold">
                Done With You
              </strong>{' '}
              engagements, Josh works closely with the client&rsquo;s existing
              team and helps them improve strategy, systems, accountability, and
              execution.
            </p>

            <div className="mt-8">
              {flowSteps.map((step, i) => (
                <div key={step.name}>
                  <div className={`rounded-xl border ${step.style} p-5`}>
                    <div className="flex items-center gap-3">
                      <span
                        className={`w-2 h-2 rounded-full ${step.dot}`}></span>
                      <p className="font-heading font-semibold text-foreground-950">
                        {step.name}
                      </p>
                    </div>
                    <p className="mt-1 text-sm text-foreground-600 pl-5">
                      {step.role}
                    </p>
                  </div>
                  {i < flowSteps.length - 1 && (
                    <div className="flex justify-center py-1.5 text-foreground-500">
                      <i className="ri-arrow-down-line text-lg"></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
